import { render, staticRenderFns } from "./StyleguideModal.vue?vue&type=template&id=5400e73e&"
import script from "./StyleguideModal.vue?vue&type=script&lang=js&"
export * from "./StyleguideModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports